export default __webpack_public_path__ + "static/media/chevron.85ad0760.svg";